import { ComponentDiscussion } from '../component.constants';
import { Settings } from 'approot/shared/richtext/richtext.constants';
import type { GetActivitiesSectionsQuery } from '../../lesson-builder.graphql.generated';
import {
  ACTIVITIES_RESPONSE_VARIANT_DRAW,
  ACTIVITIES_RESPONSE_VARIANT_TEXT,
} from 'global/constants';
import type { Pluck } from 'lib/gql/pluck';

export type ViewProps = Omit<ComponentDiscussion, '__typename'>;
export type EditProps = ViewProps;
export type SettingsProps = EditProps & {
  onCloseChildDrawer?: () => void;
};

export type DiscussionProperties = Pluck<
  Extract<
    Pluck<GetActivitiesSectionsQuery, 'getActivitiesSections.components'>,
    { __typename: 'ActivitiesDiscussionComponent' }
  >,
  'properties'
>;

export const RICHTEXT_SETTINGS: Settings = {
  placeholder: 'Type here...',
  canChangeBlockType: true,
  canBold: true,
  canItalic: true,
  canUnderline: true,
  canAddLists: true,
  canChangeHistory: true,
  canChangeFonts: true,
  canAddLinks: true,
  canAlignText: true,
  canHighlight: true,
};

export const DISCUSSION_RESPONSE_TYPES = [
  {
    label: 'Typing',
    value: ACTIVITIES_RESPONSE_VARIANT_TEXT,
  },
  {
    label: 'Drawing',
    value: ACTIVITIES_RESPONSE_VARIANT_DRAW,
  },
];

export const DISCUSSION_TYPENAME = 'ActivitiesDiscussionComponent';
